import { useEffect, useMemo, useState } from "react";
import { Search, ClipboardList } from "lucide-react";

import AdminPageHeader from "@/components/layout/AdminPageHeader";
import { Input } from "@/components/ui/input";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { SCREENS } from "@/constants/testIds";
import { listarBitacora, hidratarBitacora } from "@/data/adminBitacoraStore";

export default function AdminBitacora() {
  const [q, setQ] = useState("");
  const [tick, setTick] = useState(0);
  useEffect(() => {
    hidratarBitacora().then(() => setTick((t) => t + 1));
  }, []);
  const registros = useMemo(() => listarBitacora(), [tick]);
  const filtrados = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return registros;
    return registros.filter((r) =>
      [r.usuario, r.accion, r.modulo, r.detalle].filter(Boolean).some((x) => x.toLowerCase().includes(s)),
    );
  }, [q, registros]);

  return (
    <div data-testid={SCREENS.adminBitacora} className="flex flex-col gap-8">
      <AdminPageHeader eyebrow="Portal administrativo" title="Bitácora" description="Registro cronológico de acciones administrativas. Sólo consulta; no se edita ni elimina." />

      <div className="relative w-full max-w-md">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" />
        <Input data-testid="bitacora-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar por usuario, acción, módulo…" className="pl-9 bg-card" />
      </div>

      <div className="rounded-2xl border hairline bg-card overflow-hidden">
        <Table>
          <TableHeader className="bg-muted/40">
            <TableRow>
              <TableHead>Fecha</TableHead>
              <TableHead>Hora</TableHead>
              <TableHead>Usuario</TableHead>
              <TableHead>Acción</TableHead>
              <TableHead>Módulo</TableHead>
              <TableHead>Detalle</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filtrados.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} className="text-center py-10 text-muted-foreground">
                  <ClipboardList className="w-6 h-6 mx-auto mb-2 opacity-60" />
                  <p data-testid="bitacora-empty" className="text-sm">Aún no hay entradas en la bitácora.</p>
                </TableCell>
              </TableRow>
            )}
            {filtrados.map((r) => {
              const d = new Date(r.fecha);
              return (
                <TableRow key={r.id} data-testid={`bitacora-row-${r.id}`}>
                  <TableCell className="text-sm whitespace-nowrap">{d.toLocaleDateString("es-MX")}</TableCell>
                  <TableCell className="text-sm whitespace-nowrap tabular-nums">{d.toLocaleTimeString("es-MX", { hour: "2-digit", minute: "2-digit", second: "2-digit" })}</TableCell>
                  <TableCell className="text-sm font-medium">{r.usuario}</TableCell>
                  <TableCell><span className="text-[10px] uppercase tracking-widest text-accent">{r.accion}</span></TableCell>
                  <TableCell className="text-sm text-muted-foreground">{r.modulo}</TableCell>
                  <TableCell className="text-sm max-w-xl truncate" title={r.detalle}>{r.detalle}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
